export default "__VITE_IMAGE_ASSET__f2ece70e__";